import "./offlineNotice.css";
import offlineImg from "../../assets/images/offline.png";

const OfflineNotice = ({ isOnline, isDark }) => {
  if (isOnline) return null;

  return (
    <div
      className={`${
        isDark ? "offline-container-dark" : "offline-container"
      } `}
    >
      <img
        src={offlineImg}
        alt="No Internet Connection"
        className="offline-img"
      />
      <h2>Oops!</h2>
      <p>Uh-oh! Seems like your internet connection is down.</p>
    </div>
  );
};

export default OfflineNotice;
